import { exists } from '../runtime.js';
import { AssetDiffFromJSON, AssetDiffToJSON } from './AssetDiff.js';
import { PriceDataFromJSON, PriceDataToJSON } from './PriceData.js';

/* tslint:disable */
function SimulateTransactionResponseFromJSON(json) {
    return SimulateTransactionResponseFromJSONTyped(json);
}
function SimulateTransactionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inAssets': (json['inAssets'].map(AssetDiffFromJSON)),
        'outAssets': (json['outAssets'].map(AssetDiffFromJSON)),
        'counterparties': !exists(json, 'counterparties') ? undefined : json['counterparties'],
        'priceData': PriceDataFromJSON(json['priceData']),
        'showTotalFiat': json['showTotalFiat'],
    };
}
function SimulateTransactionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'inAssets': (value.inAssets.map(AssetDiffToJSON)),
        'outAssets': (value.outAssets.map(AssetDiffToJSON)),
        'counterparties': value.counterparties,
        'priceData': PriceDataToJSON(value.priceData),
        'showTotalFiat': value.showTotalFiat,
    };
}

export { SimulateTransactionResponseFromJSON, SimulateTransactionResponseFromJSONTyped, SimulateTransactionResponseToJSON };
